import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';

export default {
  name: 'SelectTransaction',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      keyColumn: 'transNo',
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      transactionsCols: [],
      noDataFound: false,
      showSelectedCustomer: false,
      transaction: {}
    }
  },
  computed: {
    
  },
  watch: {

  },
  created() {
    this.$root.$on('select_transaction_updated', this.init);
    this.fillTransactionsCols();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;

        if (this.dataObj.transactionNumber == 0)
          this.showSelectedCustomer = false;
        else {
          this.transaction = this.dataObj.transactions.filter(a => a.transNo == this.dataObj.transactionNumber)[0];
          this.showSelectedCustomer = true;
        }
      });
    },
    pageChange(pInfo) {
      if (this.options.page == pInfo.pageNumber && this.options.pageSize == pInfo.pageSize)
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getTransactions();
    },
    onSelectTransaction(info) {
      var trxn = info.data;
      if ((trxn === null) || (trxn === undefined))
        return;
      this.transaction = trxn;
      this.dataObj.transactionNumber = trxn.transNo;
    },
    fillTransactionsCols() {
      this.transactionsCols.push({ dataField: 'transNoAbs', caption: this.$t('activities.transNo') });
      this.transactionsCols.push({ dataField: 'transactionType', caption: this.$t('activities.type') });
      this.transactionsCols.push({ dataField: 'effectiveDate', caption: this.$t('activities.effectDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.transactionsCols.push({ dataField: 'documentNo', caption: this.$t('activities.documentRef') });
      this.transactionsCols.push({ dataField: 'debit', caption: this.$t('activities.debit') });
      this.transactionsCols.push({ dataField: 'credit', caption: this.$t('activities.credit') });
      this.transactionsCols.push({ dataField: 'vatAmountS', caption: this.$t('activities.vat') });
      this.transactionsCols.push({ dataField: 'balanceS', caption: this.$t('activities.balance') });
      this.transactionsCols.push({ dataField: 'currentReadingS', caption: this.$t('activities.reading') });
      this.transactionsCols.push({ dataField: 'consumptionS', caption: this.$t('activities.consumption') });
      this.transactionsCols.push({ dataField: 'statementNoAbs', caption: this.$t('activities.statmNo') });
      this.transactionsCols.push({ dataField: 'billingDate', caption: this.$t('activities.statmDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.transactionsCols.push({ dataField: 'propertyRef', caption: this.$t('activities.propertyRef') });
      this.transactionsCols.push({ dataField: 'meterRef', caption: this.$t('activities.meterRef') });
      this.transactionsCols.push({ dataField: 'glBatchNo', caption: this.$t('activities.batch') });
    },
    getTransactions() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Options: this.options
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/SelectTransactionActivity/GetTransactions', parameter),
        response => {
          if (response.status == 200) {
            if (response.data.items.length == 0) {
              this.dataObj.transactions = [];
              this.noDataFound = true;
            }
            else {
              this.dataObj.transactions = response.data.items;
              this.options.total = response.data.itemsCount;
              this.totalRow = response.data.itemsCount;
            }
            this.$root.$emit('datagrid_updated');
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );
    }
  },
  
}

